var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 21C16.799 21 21.5 16.299 21.5 10.5C21.5 4.70101 16.799 0 11 0C5.20101 0 0.5 4.70101 0.5 10.5C0.5 16.299 5.20101 21 11 21ZM10.9997 10.262C12.0568 10.262 17.1963 7.37187 17.1963 7.37187L17.2045 6.85549C17.2045 6.28541 16.7419 5.82273 16.1702 5.82273H5.82924C5.25813 5.82273 4.79545 6.28541 4.79545 6.85549V7.31558C4.79545 7.31558 9.99125 10.262 10.9997 10.262ZM10.9997 11.682C9.99125 11.682 4.80372 8.92101 4.80372 8.92101L4.79545 14.0835C4.79545 14.6535 5.25865 15.1162 5.82924 15.1162H16.1702C16.7419 15.1162 17.2045 14.6535 17.2045 14.0835L17.1963 8.92101C17.1963 8.92101 12.1053 11.682 10.9997 11.682Z","fill":"black"}));
}

Email.defaultProps = {"width":"22","height":"21","viewBox":"0 0 22 21","fill":"none"};

module.exports = Email;

Email.default = Email;
